import { useMemo } from "react";
import { CopyLinkButton } from "../Buttons";

import {
  HeaderContainer,
  PublishModalButtonContainer,
  PublishModalLinkContainer,
  PublishModalMessageContainer,
} from "../../CreateForm/DialogBase/styled";

import {
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ThemeProvider,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { conversationalFormsURL } from "../../../Utils/common";

const theme = createTheme({
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid lightgrey",
          fontSize: 20,
          fontWeight: 400,
          fontFamily: `"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
              "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
              "Helvetica Neue", sans-serif;`,
          padding: "15px",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "15px",
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "15px",
        },
      },
    },
  },
});

export default function PublishAlertModal({
  isOpen,
  closeHandler,
  formUUID,
  setToasterOpen,
  setToasterMessage,
  setToasterSeverity,
}: any) {
  const handleOnCopy = () => {
    navigator.clipboard
      .writeText(createdLink)
      .then(() => {
        closeHandler();
        setToasterOpen(true);
        setToasterMessage("Link copied!");
      })
      .catch(() => {
        setToasterOpen(true);
        setToasterSeverity("error");
        setToasterMessage("Error copying link");
      });
  };

  const createdLink = useMemo(() => {
    return formUUID
      ? `${conversationalFormsURL}/?id=${formUUID}`
      : "";
  }, [formUUID]);

  const renderLinkContainer = useMemo(() => {
    if (Boolean(createdLink.length)) {
      return (
        <PublishModalLinkContainer>
          <a target="_blank" rel="noreferrer" href={createdLink}>
            {createdLink}
          </a>
        </PublishModalLinkContainer>
      );
    }

    return (
      <PublishModalMessageContainer>
        Something went wrong please try again!
      </PublishModalMessageContainer>
    );
  }, [createdLink]);

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={isOpen} scroll="paper" fullWidth maxWidth="sm">
        <DialogTitle>
          <HeaderContainer>
            {formUUID ? `Published Successfully` : `Unable to Publish`}
            <IconButton onClick={closeHandler}>
              <CloseIcon />
            </IconButton>
          </HeaderContainer>
        </DialogTitle>
        <DialogContent>{renderLinkContainer}</DialogContent>
        <DialogActions>
          <PublishModalButtonContainer>
            <CopyLinkButton
              disabled={!Boolean(createdLink.length)}
              onClick={handleOnCopy}
            />
          </PublishModalButtonContainer>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
